import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[textCounter]'
})
export class CounterDirective implements AfterViewInit {
  @Input() maxCount = 100;
  @Output() maxCountReached = new EventEmitter<boolean>();

  private currentCount = 0;
  private displayElement: HTMLElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.currentCount = value.length;
    this.updateDisplay();
    if (this.currentCount >= this.maxCount) {
      this.maxCountReached.emit(true);
    }
  }

  ngAfterViewInit(): void {
    try {
      this.displayElement = this.renderer.createElement('div');
      this.renderer.setStyle(this.displayElement, 'fontSize', '0.6rem');
      this.renderer.setStyle(this.displayElement, 'textAlign', 'right');
      this.renderer.addClass(this.displayElement, 'pad-top-2');
      this.renderer.setStyle(this.displayElement, 'display', 'block');
      this.renderer.insertBefore(
        this.el.nativeElement.parentNode,
        this.displayElement,
        this.el.nativeElement.nextSibling
      );
      this.updateDisplay();
    } catch (error) {}
  }

  private updateDisplay() {
    try {
      const displayText = `${this.currentCount}/${this.maxCount}`;
      this.renderer.setProperty(this.displayElement, 'textContent', displayText);
    } catch (error) {}
  }
}
